import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  PatientsPayload,
  ActionType,
  IPatientListResponse,
} from "models/patients/patientList";
import { httpStatus } from "configs/httpStatus";
import { getPatients } from "services/patients";
import { handleSuccessAction, handleErrorAction } from "./patientListActions";

function* patientListSaga({ payload }: { payload: PatientsPayload }) {
  try {
    const response: IPatientListResponse = yield call(getPatients, payload);
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccessAction(response));
    } else if (response.status === httpStatus.StatusNotFound) {
      yield put(
        handleSuccessAction({
          ...response,
          result: {
            users: [],
            total_patients: 0,
            total_patients_in_super_city: 0,
          },
        })
      );
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetPatientListWatcher() {
  yield takeLatest(ActionType.GET_PATIENT_LIST as any, patientListSaga);
}

export default [fork(onGetPatientListWatcher)];
